/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AirtableOrderSkeleton.vue?vue&type=template&id=189369ea"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189369ea')) {
      api.createRecord('189369ea', component.options)
    } else {
      api.reload('189369ea', component.options)
    }
    module.hot.accept("./AirtableOrderSkeleton.vue?vue&type=template&id=189369ea", function () {
      api.rerender('189369ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/infoview/AirtableOrderSkeleton.vue"
export default component.exports